import { PostDocumentUploadResponse } from '@iwoca/lapi-client/edge';

import { TDocumentTypeDE } from '../../lapiOverrideTypesDE';

export const documentTypes: {
  [key: string]:
    PostDocumentUploadResponse['data']['document_type'] | TDocumentTypeDE;
} = {
  aged_debtor_report: 'aged debtor report',
  bank_statement: 'bank statement',
  management_accounts: 'management accounts',
  vat_return: 'vat return',
  company_accounts: 'business accounts',
  business_accounts: 'business accounts',
  business_plan: 'business plan',

  // DE
  bwa_hochladen: 'management accounts',
  bwa_susa_hochladen: 'management and balance accounts',
  jaehrliche_bwa_susa_hochladen: 'year end management and balance accounts',
  gesellschaftsvertrag_hochladen: 'articles of association',
  gewerbeschein_hochladen: 'trade certificate',
  aktienregisterauszug_hochladen: 'share registry',
};
